import React from 'react';
import { injectIntl } from 'gatsby-plugin-intl';

import H3 from './styledComponents/H3';
import RuleDescription from './styledComponents/RuleDescription';
import Base from './styledComponents/Base';
import IdeaGeneral from './styledComponents/IdeaGeneral';
import BadGeneral from './styledComponents/BadGeneral';
import ChapterSpace from './styledComponents/ChapterSpace';

import { Container,Cell,Grid,CardComponent,AnchorBlock,ChapterHeader,ParentAnchor } from './blockComponents'
import { PlainImage } from './imageComponents'
import { ImageMultilang } from './utility/imageMultilang'

function Logo({ 
    intl,
    activeAnchor,
    setActiveAnchor,
    pageHeight,
    refs
    }) {

    return (
        <ParentAnchor
            key='logoSection'
            blockId="logo-section"
            blockName='logoSection'
            refs={refs}>
            <ChapterHeader title={intl.formatMessage({ id: 'MainMenu_1' })} downloadLink="https://drive.google.com/drive/folders/1JKQoHzcXg_hyYfGWUpx6KmaI5g0jzLlv?usp=sharing"></ChapterHeader>
            <Container>
                <Grid>
                    <Cell col={12} colXl={10} colXxl={8} leftXl={2} leftXxl={3}>
                        <AnchorBlock 
                            key='logoMain'
                            blockName='logoMain'
                            blockId='logo-main'
                            activeAnchor={activeAnchor}
                            setActiveAnchor={setActiveAnchor}
                            pageHeight={pageHeight}
                            refs={refs}>
                            <H3 space="TopDown">{intl.formatMessage({ id: 'logo_main_title' })}</H3>
                            <div>
                                <RuleDescription space="TopDown" rule="do">{intl.formatMessage({ id: 'logo_main_1_1' })}</RuleDescription>
                                <PlainImage src="logo/main_logo_1@2x.jpg" alt="" />
                                <PlainImage src="logo/main_logo_2@2x.jpg" last="xs" alt="" />
                            </div>
                            <div>
                                <RuleDescription space="TopDown" rule="do">{intl.formatMessage({ id: 'logo_main_2_2' })}</RuleDescription>
                                <PlainImage src="logo/logo_space@2x.jpg" last="xs" alt="" />
                            </div>
                            <div>
                                <RuleDescription space="TopDown">{intl.formatMessage({ id: 'logo_main_2_3' })}</RuleDescription>
                                <Grid>
                                    <Cell col={12} colSm={6}>
                                        <PlainImage src="logo/logo_dont_2@2x.jpg" alt="" />
                                    </Cell>
                                    <Cell col={12} colSm={6}>
                                        <PlainImage src="logo/logo_dont_3@2x.jpg" alt="" />
                                    </Cell>
                                    <Cell col={12} colSm={6}>
                                        <PlainImage src="logo/logo_dont_4@2x.jpg" last="sm" alt="" />
                                    </Cell>
                                    <Cell col={12} colSm={6}>
                                        <PlainImage src="logo/logo_dont_1@2x.jpg" last="xs" alt="" />
                                    </Cell>
                                </Grid>
                            </div>
                        </AnchorBlock>

                        <AnchorBlock 
                            key='logoAdditional'
                            blockName='logoAdditional'
                            blockId='logo-additional'
                            activeAnchor={activeAnchor}
                            setActiveAnchor={setActiveAnchor}
                            pageHeight={pageHeight}
                            refs={refs}>
                            <H3 space="TopDown">{intl.formatMessage({ id: 'logo_additional_title' })}</H3>
                            <div>
                                <RuleDescription rule="do">{intl.formatMessage({ id: 'logo_additional_1_1' })}</RuleDescription>
                                <PlainImage src="logo/logomark_1@2x.jpg" alt="" />
                                <PlainImage src="logo/logomark_2@2x.jpg" last="xs" alt="" />
                            </div>
                            <Base space="TopDown">{intl.formatMessage({ id: 'logo_additional_2_2' })}</Base>
                            <Grid>
                                <Cell col={12} colSm={6}>
                                    <RuleDescription />
                                    <PlainImage src="logo/logomark_dont@2x.jpg" last="sm" alt="" />
                                </Cell>
                                <Cell col={12} colSm={6}>
                                    <RuleDescription rule="do" />
                                    <PlainImage src="logo/stationary@2x.png" last="xs" alt="" />
                                </Cell>
                            </Grid>
                        </AnchorBlock>

                        <AnchorBlock 
                            key='logoTagline'
                            blockName='logoTagline'
                            blockId='logo-tagline'
                            activeAnchor={activeAnchor}
                            setActiveAnchor={setActiveAnchor}
                            pageHeight={pageHeight}
                            refs={refs}>
                            <H3 space="TopDown">{intl.formatMessage({ id: 'logo_tagline_title' })}</H3>
                            <RuleDescription space="TopDown" rule="do">{intl.formatMessage({ id: 'logo_tagline_1_1' })}</RuleDescription>
                            <ImageMultilang
                                intl={intl} 
                                imageRu='logo/logo_tagline_1-ru@2x.jpg'
                                imageUk='logo/logo_tagline_1-uk@2x.jpg'
                                imageEn='logo/logo_tagline_1-en@2x.jpg' />
                            <ImageMultilang
                                intl={intl} 
                                imageRu='logo/logo_tagline_2-ru@2x.jpg'
                                imageUk='logo/logo_tagline_2-uk@2x.jpg'
                                imageEn='logo/logo_tagline_2-en@2x.jpg' />
                            <ImageMultilang
                                intl={intl} 
                                last="xs"
                                imageRu='logo/logo_tagline_3-ru@2x.jpg'
                                imageUk='logo/logo_tagline_3-uk@2x.jpg'
                                imageEn='logo/logo_tagline_3-en@2x.jpg' />
                        </AnchorBlock>

                        <AnchorBlock 
                            key='logoPartnerships'
                            blockName='logoPartnerships'
                            blockId='logo-partnerships'
                            activeAnchor={activeAnchor}
                            setActiveAnchor={setActiveAnchor}
                            pageHeight={pageHeight}
                            refs={refs}>
                            <H3 space="Top">{intl.formatMessage({ id: 'logo_partner_title' })}</H3>
                            <RuleDescription space="TopDown" rule="do">{intl.formatMessage({ id: 'logo_partner_1_1' })}</RuleDescription>
                            
                            <Grid>
                                <Cell col={6}>
                                    <ImageMultilang
                                        intl={intl} 
                                        // last="xs"
                                        imageRu='logo/cobranding-1-ru1@2x.jpg'
                                        imageUk='logo/cobranding-1-uk1@2x.jpg'
                                        imageEn='logo/cobranding-1-en@2x.jpg' />
                                </Cell>
                                <Cell col={6}>
                                    <ImageMultilang
                                        intl={intl} 
                                        // last="xs"
                                        imageRu='logo/cobranding-2-ru@2x.jpg'
                                        imageUk='logo/cobranding-2-uk@2x.jpg'
                                        imageEn='logo/cobranding-2-en@2x.jpg' />
                                </Cell>
                            </Grid>
                            <ImageMultilang
                                intl={intl} 
                                imageRu='logo/cobranding-3-ru@2x.jpg'
                                imageUk='logo/cobranding-3-uk@2x.jpg'
                                imageEn='logo/cobranding-3-en@2x.jpg' />
                            <ImageMultilang
                                intl={intl} 
                                last="xs"
                                imageRu='logo/cobranding-4-ru@2x.jpg'
                                imageUk='logo/cobranding-4-uk@2x.jpg'
                                imageEn='logo/cobranding-4-en@2x.jpg' />
                            <IdeaGeneral space="Top">{intl.formatMessage({ id: 'logo_partner_1_2' })}</IdeaGeneral>
                        </AnchorBlock>

                        <AnchorBlock 
                            key='logoTag'
                            blockName='logoTag'
                            blockId='logo-tag'
                            activeAnchor={activeAnchor}
                            setActiveAnchor={setActiveAnchor}
                            pageHeight={pageHeight}
                            refs={refs}>
                            <H3 space="TopDown">{intl.formatMessage({ id: 'logo_partner_2_1' })}</H3>
                            <RuleDescription space="TopDown" rule="do">{intl.formatMessage({ id: 'logo_partner_2_3' })}</RuleDescription>
                            <Grid>
                                <Cell col={6}>
                                    {/* <PlainImage src="logo/partner-stamp-1@2x.jpg" alt="" /> */}
                                    <ImageMultilang
                                        intl={intl} 
                                        last=""
                                        imageRu='logo/partner-stamp-1-ru1@2x.jpg'
                                        imageUk='logo/partner-stamp-1-uk1@2x.jpg'
                                        imageEn='logo/partner-stamp-1-en@2x.jpg' />
                                </Cell>
                                <Cell col={6}>
                                    {/* <PlainImage src="logo/partner-stamp-2@2x.jpg" alt="" /> */}
                                    <ImageMultilang
                                        intl={intl} 
                                        last=""
                                        imageRu='logo/partner-stamp-2-ru@2x.jpg'
                                        imageUk='logo/partner-stamp-2-uk@2x.jpg'
                                        imageEn='logo/partner-stamp-2-en@2x.jpg' />
                                </Cell>
                                <Cell col={6}>
                                    {/* <PlainImage src="logo/partner-stamp-3@2x.jpg" last="sm" alt="" /> */}
                                    <ImageMultilang
                                        intl={intl} 
                                        last="sm"
                                        imageRu='logo/partner-stamp-3-ru@2x.jpg'
                                        imageUk='logo/partner-stamp-3-uk@2x.jpg'
                                        imageEn='logo/partner-stamp-3-en@2x.jpg' />
                                </Cell>
                                <Cell col={6}>
                                    {/* <PlainImage src="logo/partner-stamp-4@2x.jpg" last="xs" alt="" /> */}
                                    <ImageMultilang
                                        intl={intl} 
                                        last="xs"
                                        imageRu='logo/partner-stamp-4-ru@2x.jpg'
                                        imageUk='logo/partner-stamp-4-uk@2x.jpg'
                                        imageEn='logo/partner-stamp-4-en@2x.jpg' />
                                </Cell>
                            </Grid>
                            <IdeaGeneral space="Top">{intl.formatMessage({ id: 'logo_partner_2_2' })}</IdeaGeneral>

                            <BadGeneral space="Top">{intl.formatMessage({ id: 'logo_partner_2_4' })}</BadGeneral>
                        </AnchorBlock>
                        
                        <AnchorBlock 
                            key='logoTechnologies'
                            blockName='logoTechnologies'
                            blockId='logo-technologies'
                            activeAnchor={activeAnchor}
                            setActiveAnchor={setActiveAnchor}
                            pageHeight={pageHeight}
                            refs={refs}>
                            <H3 space="TopDown">{intl.formatMessage({ id: 'logo_technology_title' })}</H3>
                            <Grid>
                                <Cell col={12} colSm={6}>
                                    <CardComponent src="logo/malevich@2x.jpg" title={intl.formatMessage({ id: 'logo_technology_1_1' })} text={intl.formatMessage({ id: 'logo_technology_1_2' })} />
                                </Cell>
                                <Cell col={12} colSm={6}>
                                    <CardComponent src="logo/cloud@2x.jpg" title={intl.formatMessage({ id: 'logo_technology_2_1' })} text={intl.formatMessage({ id: 'logo_technology_2_2' })} />
                                </Cell>
                                <Cell col={12} colSm={6}>
                                    <CardComponent src="logo/api@2x.jpg" title={intl.formatMessage({ id: 'logo_technology_3_1' })} text={intl.formatMessage({ id: 'logo_technology_3_2' })} />
                                </Cell>
                                <Cell col={12} colSm={6}>
                                    <CardComponent src="logo/jeweller@2x.jpg" title={intl.formatMessage({ id: 'logo_technology_4_1' })} text={intl.formatMessage({ id: 'logo_technology_4_2' })} />
                                </Cell>
                                <Cell col={12} colSm={6}>
                                    <CardComponent src="logo/translator@2x.jpg" title={intl.formatMessage({ id: 'logo_technology_5_1' })} text={intl.formatMessage({ id: 'logo_technology_5_2' })} last="sm" />
                                </Cell>
                                <Cell col={12} colSm={6}>
                                    <CardComponent src="logo/lisa@2x.jpg" title={intl.formatMessage({ id: 'logo_technology_6_1' })} text={intl.formatMessage({ id: 'logo_technology_6_2' })} last="xs" />
                                </Cell>
                            </Grid>
                        </AnchorBlock>

                        <AnchorBlock 
                            key='logoApplications'
                            blockName='logoApplications'
                            blockId='logo-applications'
                            activeAnchor={activeAnchor}
                            setActiveAnchor={setActiveAnchor}
                            pageHeight={pageHeight}
                            refs={refs}>
                            <H3 space="TopDown">{intl.formatMessage({ id: 'logo_apps_title' })}</H3>
                            <PlainImage src="logo/apps_1@2x.jpg" alt="" />
                            <PlainImage src="logo/apps_2@2x.jpg" alt="" />
                            <PlainImage src="logo/apps_3@2x.jpg" alt="" />
                            {/* <PlainImage src="logo/911-logo@2x.jpg" last="xs" alt="" /> */}
                        </AnchorBlock>
                    </Cell>
                </Grid>
            </Container>
            <ChapterSpace />
        </ParentAnchor>
    )
}


export default injectIntl(Logo)